/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/warranty_product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "CreateWarrantyProductsOrderRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "selections": {
                        "type": "squareup.solidshop.v2.service.CreateWarrantyProductsOrderRequest.WarrantySelection",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "WarrantySelection": {
                        "fields": {
                          "serialNumber": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "productKey": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "warrantyReasonId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "warrantyReasonDetail": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "warrantyStatus": {
                            "type": "squareup.solidshop.v2.resources.WarrantyStatus",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CreateWarrantyProductsOrderResponse": {
                    "fields": {
                      "orderNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE CreateWarrantyProductsOrderRequest @ squareup/solidshop/v2/service/warranty_products/create_warranty_products_order.proto at 11:1
 */
export const CreateWarrantyProductsOrderRequest = $root.lookupType('squareup.solidshop.v2.service.CreateWarrantyProductsOrderRequest');
fixType(CreateWarrantyProductsOrderRequest);
Builder.createAndAttachToType(CreateWarrantyProductsOrderRequest);
/**
 * SOURCE WarrantySelection @ squareup/solidshop/v2/service/warranty_products/create_warranty_products_order.proto at 12:3
 */
CreateWarrantyProductsOrderRequest.WarrantySelection = $root.lookupType('squareup.solidshop.v2.service.CreateWarrantyProductsOrderRequest.WarrantySelection');
fixType(CreateWarrantyProductsOrderRequest.WarrantySelection);
Builder.createAndAttachToType(CreateWarrantyProductsOrderRequest.WarrantySelection);
/**
 * SOURCE CreateWarrantyProductsOrderResponse @ squareup/solidshop/v2/service/warranty_products/create_warranty_products_order.proto at 39:1
 */
export const CreateWarrantyProductsOrderResponse = $root.lookupType('squareup.solidshop.v2.service.CreateWarrantyProductsOrderResponse');
fixType(CreateWarrantyProductsOrderResponse);
Builder.createAndAttachToType(CreateWarrantyProductsOrderResponse);
